'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _withProps = require('recompose/withProps');

var _withProps2 = _interopRequireDefault(_withProps);

var _objectEditorEnhancer = require('../../../DocEditor/objectEditorEnhancer');

var _objectEditorEnhancer2 = _interopRequireDefault(_objectEditorEnhancer);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _AuthBody = require('./AuthBody');

var _AuthBody2 = _interopRequireDefault(_AuthBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _compose2.default)((0, _withProps2.default)(function (_ref) {
  var actions = _ref.actions,
      emptyAuth = _ref.emptyAuth;
  return {
    schema: {
      type: 'Object',
      contents: _ramda2.default.map(function () {
        return {
          type: 'Object',
          contents: _ramda2.default.zipObj(actions, _ramda2.default.repeat({ type: 'Boolean' }, actions.length))
        };
      }, emptyAuth || {})
    }
  };
}), _objectEditorEnhancer2.default)(_AuthBody2.default);


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/GroupEditor/AuthEditor/AuthBody/index.js
// module id = 1736
// module chunks = 0